"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = Footer;
var jsx_runtime_1 = require("react/jsx-runtime");
var logo_1 = require("../logo");
var copyright_1 = require("./copyright");
function Footer() {
    return ((0, jsx_runtime_1.jsx)("div", { className: "container px-6 ", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex gap-2 items-center", children: (0, jsx_runtime_1.jsx)(logo_1.LogoComponent, {}) }), (0, jsx_runtime_1.jsx)(copyright_1.Copyright, {})] }) }));
}
